import { SafePaddingContainer } from '@/components/SafePaddingContainer';
import { SecondaryHeader } from '@/components/SecondaryHeader';
import { AccountSettings } from '@/components/Settings/AccountSettings';
import { NotificationSettings } from '@/components/Settings/NotificationSettings';
import { ExperienceSettings } from '@/components/Settings/ExperienceSettings';
import { Button } from '@/components/ui/button';
import { AgreementsSection } from '@/components/Settings/AgreementsSection';
import { LogoutSection } from '@/components/Settings/LogoutSection';
import { useViewTransition } from '@/hooks/useViewTransition';
import {
    show as showIntercomOverlay,
  } from "@intercom/messenger-js-sdk";
import { SubscriptionSettings } from '@/components/Settings/SubscriptionSettings';

export function SettingsPage() {
    const { navigateNormal } = useViewTransition();

    const openWallet = () => {
        navigateNormal('/wallet', {
            replace: false,
            viewTransition: true,
        });
    };

    return (
        <div className="flex flex-col h-screen overflow-y-scroll pb-10 bg-white">
            <SafePaddingContainer orientation='header' className='bg-blue'>
                <SecondaryHeader text={'Settings'} />
                {/* Main content */}
            </SafePaddingContainer>
            <SafePaddingContainer orientation='footer' className='bg-white'>
                <div className="p-4 max-w-md mx-auto mt-6">
                    <AccountSettings />
                    <ExperienceSettings />
                    <NotificationSettings />
                    <SubscriptionSettings />
                    <div className='mb-8'>
                        <h2 className="text-2xl font-bold text-blue-dark mb-6">Payment settings</h2>
                        <Button 
                            className='py-6 bg-blue text-white text-2xl font-bold w-full rounded-lg'
                            onClick={() => openWallet()}
                        >
                            View My Wallet
                        </Button>
                    </div>
                    <div className='mb-8'>
                        <h2 className="text-2xl font-bold text-blue-dark mb-6">Contact support</h2>
                        <Button 
                            className={'py-6 bg-blue text-white text-2xl font-bold w-full rounded-lg}'}
                            shine
                            onClick={() => showIntercomOverlay()}
                        >
                            Contact support
                        </Button>
                    </div>
                    <AgreementsSection />
                    <LogoutSection />
                </div>
            </SafePaddingContainer>
        </div>
    );
}


// import React from 'react';

// const InterfaceRecreation = () => {
//   return (
//     <div className="flex flex-col gap-4 max-w-md">
//       <div className="flex gap-2">
//         <input 
//           type="text" 
//           className="border rounded p-2 flex-grow" 
//           placeholder="Pedro Duarte" 
//           defaultValue="Pedro Duarte"
//         />
//         <button className="bg-gray-200 hover:bg-gray-300 rounded px-4 py-2 text-gray-700">
//           Initiate
//         </button>
//       </div>
      
//       <div className="bg-red-100 border border-red-200 rounded p-3 text-center text-red-600 font-medium">
//         Minimum $10 withdrawal
//       </div>
//     </div>
//   );
// };
